import { jsObtainContext, jsCallEntityMethod } from 'doric/src/runtime/sandbox';
import { createContext, destroyContext } from "./DoricDriver";
import { DoricStackNode } from './shader/DoricStackNode';
const doricContexts = new Map;
let __contextId__ = 0;
function getContextId() {
    return `context_${__contextId__++}`;
}
export function getDoricContext(contextId) {
    return doricContexts.get(contextId);
}
export class DoricContext {
    constructor(content) {
        this.contextId = getContextId();
        this.pluginInstances = new Map;
        this.headNodes = new Map;
        createContext(this.contextId, content);
        doricContexts.set(this.contextId, this);
        this.rootNode = new DoricStackNode(this);
    }
    get panel() {
        var _a;
        return (_a = jsObtainContext(this.contextId)) === null || _a === void 0 ? void 0 : _a.entity;
    }
    invokeEntityMethod(method, ...otherArgs) {
        const argumentsList = [this.contextId];
        for (let i = 0; i < arguments.length; i++) {
            argumentsList.push(arguments[i]);
        }
        return Reflect.apply(jsCallEntityMethod, this.panel, argumentsList);
    }
    init(frame, extra) {
        this.invokeEntityMethod("__init__", frame, extra ? JSON.stringify(extra) : undefined);
    }
    teardown() {
        for (let plugin of this.pluginInstances.values()) {
            plugin.onTearDown();
        }
        destroyContext(this.contextId);
    }
}
